// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__v0DWB","content":"ManualTimeModal_content__1aTeS"};